export class ReceptorBhe {
   rutReceptor: number;
   dvReceptor: string;
   rutStringReceptor: string;
   nombreReceptor: string;
   direccionReceptor: string;
   regionReceptor: string;
   codigoRegionReceptor: number;
   comunaReceptor: string;
   codigoComunaReceptor: number;
}
